import { SerializableObject } from '../../common-react/core';

export class RefundResponse extends SerializableObject {
    public identificationNumber: string;
    public name: string;
    public firstErrorDateTime: string;
    public lastErrorDateTime: string;
    public numberOfShipments: number;
    public amountCorrected: number;
    public amountInCorrection: number;
    public amountUncorrected: number;
    public totalAmount: number;
    public currency: string;
    public hasSubmittedBankInfo: boolean;
    public submitDateTime: string;
    public accountBank: string;
    public accountType: string;
    public accountNumber: string;
    public accountIdentificationNumber: string;
    public hasBeenCorrected: boolean;
    public correctionDateTime: string;
    public message: string;
}
